





import {
  defineComponent,
} from '@vue/composition-api';

import CommonFormWithMaterialEditor from '@/components/Store/CommonFormWithMaterialEditor.vue';

const Create = defineComponent({
  components: {
    CommonFormWithMaterialEditor,
  },
  // setup() {},
});

export default Create;
